// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { CustomerRegistrationResponseFragmentDoc } from '../auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../fragments/costumerConsultant.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireCompleteNewCustomerDocument = `
    mutation questionnaireCompleteNewCustomer($input: QuestionnaireCompleteInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  questionnaireCompleteNewCustomer(input: $input, customer: $customer) {
    __typename
    customer {
      ...customerRegistrationResponse
    }
  }
}
    ${CustomerRegistrationResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}`;

export function useQuestionnaireCompleteNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.QuestionnaireCompleteNewCustomerMutation, SchemaTypes.QuestionnaireCompleteNewCustomerMutationVariables>(QuestionnaireCompleteNewCustomerDocument);
};